import React, { useState, useEffect } from 'react';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';
import Dialog from '@mui/material/Dialog';
import Alert from '@mui/material/Alert';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemButton from '@mui/material/ListItemButton';
import Chip from '@mui/material/Chip';
import CloseIcon from '@mui/icons-material/CloseRounded';
import Divider from '@mui/material/Divider';
import LoadingSmall from '../parts/LoadingSmall'
import axios from 'axios';
import endpoints, { getBackendUrl } from '../../../endpoints';
import { useSelector, useDispatch } from 'react-redux'

import SearchViewModal from '../modals/SearchViewModal'

export default function ContentSummaryModal(props) {
    const [data, setData] = useState(props.data)
    const [reason, setReason] = useState(null)
    const [loadingReason, setLoadingReason] = useState(false)

    const [searchView, setSearchView] = useState(null)

    const token = useSelector((state) => state.auth.token)

    const loadReasonHandle = async () => {
        setLoadingReason(true)
        let uri = getBackendUrl(endpoints.ai_reason, token).replace('{id}', props.data.id)
        try {
            let res = await axios.get(uri)
            setReason(res.data.items)
        } catch (e) {

        }
        setLoadingReason(false)
    }

    useEffect(() => {
        if (!props?.data) {
            setTimeout(() => {
                setReason(null)
                setLoadingReason(false)
            }, 500)
        }
    }, [props])

    const searchViewOpen = async (id) => {
        let uri = getBackendUrl(endpoints.feedcontents_data, token).replace('{id}', id)
        try {
            let res = await axios.get(uri)
            setSearchView(res.data.item)
        } catch (e) {

        }
    }
       
    return (
        <Dialog open={props.data ? true : false} onClose={props.onClose} fullWidth maxWidth="md" >
            <DialogTitle id="alert-dialog-title">
                Analysis Details
                <IconButton
                    onClick={props.onClose}
                    sx={{
                      position: 'absolute',
                      right: 8,
                      top: 8,
                      color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent>
                <Stack spacing={3}>
                    <Divider textAlign="left">SUMMARY</Divider>
                    {props.data?.summary}
                    
                    <Divider textAlign="left">SUITABLE</Divider>
                    {props.data?.suitable}

                    <Divider textAlign="left">REASON</Divider>
                    <Stack style={{ position: 'relative', minHeight: loadingReason ? 100 : 'auto', }}>
                        { reason ? 
                        <List>
                            {reason?.map((item) => {
                                return (
                                    <ListItemButton onClick={() => {searchViewOpen(item.feed_content_id)}}>
                                        <ListItemText primary={ '[' + item.similarity + '] ' + item.title } secondary={ item.summary } />
                                    </ListItemButton>
                                )
                            })}
                        </List>
                        : null }
                        { reason && reason.length == 0 ? 
                        <p>No records found.</p>
                        : null }

                        { !reason && !loadingReason ?
                        <Stack direction="row" alignItems="center" justifyContent="center">
                            <Button variant="contained" onClick={loadReasonHandle}>Load Reason</Button>
                        </Stack> : null }

                        { !reason && loadingReason ? <LoadingSmall /> : null }
                    </Stack>
                </Stack>
                <SearchViewModal 
                    dialogData={searchView}
                    onClose={() => {setSearchView(null)} }
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={props.onClose}>Close</Button>
            </DialogActions>
        </Dialog>
    )
}